import client from './client';

// get User List ALL
export const userList = () => 
  client.get('/admin/user/getAll');

export const user = () => {
  
}